module.exports = __webpack_public_path__ + "fonts/Coustard-Regular.ttf.2d3bdaa3.eot";